/* DEMARE Modell-Memory · 2026-05-23 ·
   Speichert die zuletzt gewählte Smartphone-Variante im LocalStorage und wählt sie auf jeder PDP automatisch vor.
   Plus: liest Filter-Parameter aus Collection-URLs (?filter.p.tag=iphone-15) und übernimmt das Modell.
*/
(function(){
  var STORAGE_KEY = 'demare_preferred_model';
  var STORAGE_TS  = 'demare_preferred_model_ts';
  var MAX_AGE_MS  = 30*24*60*60*1000; // 30 Tage

  function getStored(){
    try{
      var ts = parseInt(localStorage.getItem(STORAGE_TS)||'0',10);
      if(!ts || (Date.now()-ts) > MAX_AGE_MS) return null;
      return localStorage.getItem(STORAGE_KEY);
    }catch(e){return null;}
  }
  function setStored(model){
    try{
      localStorage.setItem(STORAGE_KEY, model);
      localStorage.setItem(STORAGE_TS, String(Date.now()));
    }catch(e){}
  }

  function parseModelFromUrl(){
    var params = new URLSearchParams(location.search);
    var keys = ['filter.p.tag','filter.p.option.modell','filter.v.option.smartphone-modell','q','model'];
    for(var i=0;i<keys.length;i++){
      var v = params.get(keys[i]);
      if(!v) continue;
      var m = v.match(/(iphone\s*\d+[a-z\s]*?(?:pro\s*max|pro|plus|mini|air|e)?|samsung\s*[as]\d+\s*(?:plus|ultra|fe)?|google\s*pixel\s*\d+\s*(?:pro|xl)?|xiaomi\s*\d+)/i);
      if(m) return m[1].trim();
    }
    return null;
  }

  function fuzzyMatch(target, options){
    // Loose match: lowercase, remove punctuation/spaces
    function norm(s){return (s||'').toLowerCase().replace(/[^a-z0-9]/g,'');}
    var t = norm(target);
    if(!t) return null;
    var best = null, bestScore = 0;
    for(var i=0;i<options.length;i++){
      var n = norm(options[i].value);
      if(n === t) return options[i];
      // partial: t contains n or n contains t
      if(n.indexOf(t)>-1 || t.indexOf(n)>-1){
        var score = Math.min(n.length, t.length);
        if(score > bestScore){bestScore = score; best = options[i];}
      }
    }
    return best;
  }

  function autoselect(){
    // Find variant <select> on PDP (Shopify standard + ecom-themed pattern)
    var selects = document.querySelectorAll('select[name^="options["], select[id*="option-"], select.variant-selector, .selector-wrapper select');
    if(!selects.length) return;
    // Take first one (in DEMARE: Smartphone-Modell)
    var sel = selects[0];
    if(!sel || sel.options.length<2) return;

    var fromUrl = parseModelFromUrl();
    var stored = getStored();
    var candidate = fromUrl || stored;
    if(!candidate) return;

    var match = fuzzyMatch(candidate, sel.options);
    if(match && sel.value !== match.value){
      sel.value = match.value;
      sel.dispatchEvent(new Event('change', {bubbles:true}));
      console.log('[DEMARE] Modell-Memory: vorausgewählt → '+match.value);
    }
  }

  function listenForChanges(){
    document.addEventListener('change', function(e){
      var t = e.target;
      if(!t || t.tagName !== 'SELECT') return;
      // Heuristik: nur erste Option-Select (Smartphone-Modell)
      var name = (t.name||'')+(t.id||'');
      if(/option|modell|smartphone|variant|model/i.test(name)){
        if(t.value && t.value.length > 2){
          setStored(t.value);
        }
      }
    }, true);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ autoselect(); listenForChanges(); });
  }else{
    autoselect();
    listenForChanges();
  }
})();
